import { render, staticRenderFns } from "./share-sns.vue?vue&type=template&id=6a2c7ac0&scoped=true"
import script from "./share-sns.vue?vue&type=script&lang=ts"
export * from "./share-sns.vue?vue&type=script&lang=ts"
import style0 from "./share-sns.vue?vue&type=style&index=0&id=6a2c7ac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2c7ac0",
  null
  
)

export default component.exports